module.exports = __webpack_public_path__ + "img/astronaut3.dcea4eca.jpg";